// extracted by mini-css-extract-plugin
var _1 = "clUN1";
var _2 = "DzTUe";
export { _1 as "base", _2 as "dragging" }
